import React from 'react';

import autoBind from 'react-autobind';
import { If } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"

import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';

class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasLabel: true,
      showUsername: false,
    };
    autoBind(this);

    if (this.props.hasLabel != null) {
      this.state.hasLabel = this.props.hasLabel;
    }
    if (this.props.showUsername != null) {
      this.state.showUsername = this.props.showUsername;
    }
  }

  userOptionChanged(e) {
    if (this.props.parent.userOptionChanged) {
      this.props.parent.userOptionChanged(e);
    }
  }

  render() {
    return (
      <FormControl>
        <If condition={this.state.hasLabel}>
          <InputLabel>{Localization.strings.USER_LIST}</InputLabel>
        </If>
        <Select
          value={this.props.userOption}
          onChange={this.userOptionChanged}
        >
          <MenuItem key={-1} value={-1}>{Localization.strings.ALL_USERS}</MenuItem>
          <If condition={this.props.userList.length == 0}>
            <MenuItem value={0}>No User</MenuItem>
          </If>
          {this.props.userList.map( (row, i) => {
            return (
              <MenuItem key={i} value={i}>{(this.state.showUsername? row['username'] : row['display_name'])}</MenuItem>
            );
          })}
        </Select>
      </FormControl>
    )
  }
}

export default UserList;
